'use client';

import { Box } from '@viewup/ui';
import { usePathname } from 'next/navigation';

export const BackgroundHeightBox = () => {
  const path = usePathname();

  return (
    <Box
      bgColor={path?.includes('/account/') ? 'system.white' : 'gray.50'}
      height='100%'
      position='absolute'
      top={0}
      width='100%'
      zIndex={-1}
    />
  );
};
